import React, { useMemo, useState } from "react";
import { Form, OverlayTrigger, Tooltip } from "react-bootstrap";

const BackupBidSection = ({
  propertyToolTip = {},
  nextBid = {},
  holdAsBackup,
  setHoldAsBackup,
  backupDuration,
  setBackupDuration,
}) => {
  //   const [holdAsBackup, setHoldAsBackup] = useState(null);
  //   const [backupDuration, setBackupDuration] = useState("");

  const MS_PER_DAY = 86400000;

  // Simulated current date and auction time left from server
  const currentDate = new Date();
  const auctionTimeLeft =
    propertyToolTip?.listingPriceDetail?.auctionTimeLeft ?? -51492322996;

  const auctionEndTime = useMemo(() => {
    const currentTimestamp = currentDate.getTime();
    return auctionTimeLeft <= 0
      ? currentTimestamp
      : currentTimestamp + auctionTimeLeft;
  }, [auctionTimeLeft, currentDate]);

  const formattedBackupHoldReleaseDate = useMemo(() => {
    if (
      !auctionEndTime ||
      !backupDuration ||
      propertyToolTip?.isBidDepositRequired !== "Y"
    ) {
      return null;
    }

    const releaseDate = new Date(auctionEndTime + backupDuration * MS_PER_DAY);
    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    return `${
      months[releaseDate.getMonth()]
    } ${releaseDate.getDate()}, ${releaseDate.getFullYear()}`;
  }, [auctionEndTime, backupDuration, propertyToolTip]);

  return (
    <>
      <Form.Group className="mb-3">
        <p>
          Would you like to hold this bid as a backup bid?
          {/* {propertyToolTip?.isBidDepositRequired === "Y" && (
            <OverlayTrigger
              placement="top"
              overlay={
                <Tooltip className="tool-tip-text" id="tooltip-total-due">
                  Your BackupBid and BidDeposit hold will be in place from the
                  end of the auction through the duration period selected. The
                  seller may consider backup bids if they are unable to proceed
                  with the selected bidder.
                </Tooltip>
              }
            >
              <span className="placebid-tooltip-icon ms-2">i</span>
            </OverlayTrigger>
          )} */}
        </p>

        <div
          style={{
            display: "flex",
            // alignContent: "center",
            // justifyContent: "space-around",
          }}
          className="backup-bid-section-hold"
        >
          <Form.Check
            type="radio"
            label="Yes, hold it as a backup bid"
            name="backupBidOption"
            id="holdAsBackup"
            checked={holdAsBackup === true}
            onChange={() => setHoldAsBackup(true)}
            className="mb-2 hold-best-bid"
          />
          <Form.Check
            type="radio"
            label="No, don't hold it as a backup bid"
            name="backupBidOption"
            id="dontHoldAsBackup"
            checked={holdAsBackup === false}
            onChange={() => {
              setHoldAsBackup(false);
              setBackupDuration("");
            }}
            className="mb-2 hold-best-bid hold-best-bid-left"
          />
        </div>
      </Form.Group>

      <Form.Group className="mb-3">
        {/* <Form.Label>Select Duration</Form.Label> */}
        <Form.Select
          value={backupDuration}
          //   onChange={(e) => setBackupDuration(Number(e.target.value))}
          onChange={(e) => {
            const val = e.target.value;
            setBackupDuration(val === "" ? "" : Number(val));
          }}
          disabled={!holdAsBackup}
          className="w-25"
        >
          <option value="">Select Duration</option>
          {nextBid?.backupBidExpiryDaysList?.map((duration, i) => (
            <option key={i} value={duration}>
              {duration} days
            </option>
          ))}
        </Form.Select>
      </Form.Group>

      {holdAsBackup &&
        backupDuration &&
        propertyToolTip?.isBidDepositRequired === "Y" &&
        formattedBackupHoldReleaseDate && (
          <p
            className="mt-3 label-tc-term-best-bid"
            // style={{ marginLeft: "5rem" }}
          >
            If your backup bid is selected, the bid deposit hold will remain in
            place until you provide the signed purchase and sale agreement and
            the required earnest money deposit. Failure to deliver these items
            (if your backup bid is selected) will result in the hold becoming a
            charge as per our terms and conditions. If your backup bid is not
            selected, the bid deposit hold will be released on or about{" "}
            <strong className="ms-1">{formattedBackupHoldReleaseDate}</strong>.
            Please allow 4 to 7 days for the bid deposit hold release to be
            reflected on your credit card.
          </p>
        )}
    </>
  );
};

export default BackupBidSection;
